export default __webpack_public_path__ + "static/media/include_5_female@3x.166cc0ec.jpg";